import { useState, useMemo, createRef } from 'react';
import { OTP_LENGTH } from 'constants/global';
import PropTypes from 'prop-types';
import './styles.scss';

const InputOtp = ({
  className = '',
  onChange,
}) => {
  const [otp, setOtp] = useState(Array(OTP_LENGTH).fill(''));
  const refs = useMemo(() => {
    return Array.from({ length: OTP_LENGTH }).map(() => createRef());
  }, []);

  const handleChange = (index, event) => {
    const { value } = event.target;
    const newOtp = [...otp];
    newOtp[index] = value.slice(-1);

    setOtp(newOtp);
    onChange(newOtp.join(''));

    if (value && index < (OTP_LENGTH - 1)) {
      refs[index + 1].current.focus();
    }
  };

  const handleKeyDown = (index, event) => {
    if (['-', '.', '+', ',', 'e'].includes(event.key)) {
      event.preventDefault();
    }
    if (event.key === 'Backspace' && index > 0 && !otp[index]) {
      refs[index - 1].current.focus();
    }
  };

  return (
    <div className={`otp_input ${className}`}>
      {otp.map((digit, index) => (
        <input
          key={`otp-${index}`}
          type='number'
          pattern='\d*\.?\d*'
          maxLength={1}
          value={digit}
          onChange={(e) => handleChange(index, e)}
          onKeyDown={(e) => handleKeyDown(index, e)}
          ref={refs[index]}
          style={{
            width: '50px',
            height: '50px',
            marginRight: '10px',
            fontSize: '1.2em',
            textAlign: 'center',
            border: '1px solid #1A1A1A',
            borderRadius: '5px',
          }}
        />
      ))}
    </div>
  );
};

InputOtp.propTypes = {
  onChange: PropTypes.func.isRequired,
  className: PropTypes.string,
};

export default InputOtp;
